module.exports = __webpack_public_path__ + "static/media/account.b8982e19.png";